import { toDataURL } from "qrcode";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

import { Caption } from "@bokio/designsystem/components/TypographicElements/TypographicElements";

import type { FC } from "react";

import * as styles from "./sveaBankIdModalDialogBase.scss";

interface SveaBankIdQrCodeButtonProps {
	qrCode: string | undefined;
	ariaLabel: string;
	fullscreenAriaLabel: string;
	fullscreenImageAlt: string;
	timerText: string;
}

export const SveaBankIdQrCodeButton: FC<SveaBankIdQrCodeButtonProps> = ({
	qrCode,
	ariaLabel,
	fullscreenAriaLabel,
	fullscreenImageAlt,
	timerText,
}) => {
	const [qrImageSrc, setQrImageSrc] = useState<string>();
	const [qrFullscreen, setQrFullscreen] = useState(false);

	useEffect(() => {
		if (!qrCode) {
			return;
		}
		let stillMounted = true;
		toDataURL(qrCode, { width: 400, margin: 3, errorCorrectionLevel: "L" })
			.then(url => stillMounted && setQrImageSrc(url))
			.catch(() => stillMounted && setQrImageSrc(undefined));
		return () => {
			stillMounted = false;
			setQrImageSrc(undefined);
		};
	}, [qrCode]);

	if (!qrImageSrc) {
		return null;
	}

	return (
		<>
			<div className={styles.qrWrapper}>
				<button className={styles.qrButton} onClick={() => setQrFullscreen(true)} aria-label={ariaLabel}>
					<img src={qrImageSrc} width={180} alt="" aria-hidden="true" />
				</button>
				<span className={styles.timerText}>
					<Caption>{timerText}</Caption>
				</span>
			</div>
			{qrFullscreen &&
				createPortal(
					<div
						className={styles.qrFullscreenOverlay}
						onClick={() => setQrFullscreen(false)}
						role="dialog"
						aria-modal="true"
						aria-label={fullscreenAriaLabel}
					>
						<img src={qrImageSrc} width={400} alt={fullscreenImageAlt} />
					</div>,
					document.body,
				)}
		</>
	);
};
